import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6e2efae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "station-selector" }

import { computed, onMounted } from 'vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  props: {
  stationType: {
    type: String,
    default: 'rain',
  },
  showStations: {
    type: Boolean,
    default: true,
  },
},
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props



const initDataStore = useInitDataStore()
const globalStore = useGlobalStore()


const defaultArea = computed(() => {
  return initDataStore.areaList[0].id
})

const areaOptions = computed<{ label: string; value?: string }[]>(() => {
  const list =
    initDataStore.areaList?.map(area => ({
      label: area.name,
      value: area.id,
    })) || []

  return list
})

const options = computed(() => {
  const stationType = props.stationType

  return stations.value
    .filter(station => {
      const list = station.fieldId
      const includeWaterLevel = list.includes('water_level')
      const includeRain = list.includes('move_rain_min_10')
      const includeWeather = list.includes('rainfall')

      if (stationType === 'all') {
        return true
      }

      if (stationType === 'observable') {
        return includeWaterLevel || includeRain || includeWeather
      }

      if (stationType === 'water') {
        return includeWaterLevel || includeWeather
      }

      return includeRain
    })
    .map(station => ({
      label: station.name,
      value: station.stationId,
    }))
})

const stations = computed(() => {
  if (!initDataStore.areaList) {
    return []
  }

  const area = initDataStore.areaList.find(a => a.id === globalStore.currentArea?.id)

  if (area) {
    return area.stations()
  } else {
    return initDataStore.initData.stationList
  }
})

const handleChangeArea = (value: string) => {
  const area = initDataStore.findArea(value)

  globalStore.currentArea = area

  const stationIds = options.value.map(o => o.value)

  if (area && !stationIds.includes(globalStore.currentStation?.stationId || '')) {
    globalStore.currentStation = initDataStore.findStation(options.value[0].value)
  }
}

const handleChange = (value: string) => {
  const station = initDataStore.initData.stations.findById(value)

  globalStore.currentStation = station
  emit('change')
}

onMounted(() => {
  if (!globalStore.currentArea) {
    const area = initDataStore.areaList.find(a => a.id === defaultArea.value)

    globalStore.currentArea = area

    const stationIds = options.value.map(o => o.value)

    if (area && !stationIds.includes(globalStore.currentStation?.stationId || '')) {
      globalStore.currentStation = stations.value[0]
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_udc_select = _resolveComponent("udc-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_udc_select, {
      onChange: handleChangeArea,
      modelValue: _unref(globalStore).currentArea?.id || _unref(defaultArea),
      options: _unref(areaOptions),
      "default-label": "全域"
    }, null, 8, ["modelValue", "options"]), [
      [_vShow, _unref(areaOptions).length > 1]
    ]),
    _withDirectives(_createVNode(_component_udc_select, {
      onChange: handleChange,
      modelValue: _unref(globalStore).currentStation?.stationId,
      options: _unref(options),
      "default-label": "局選択"
    }, null, 8, ["modelValue", "options"]), [
      [_vShow, __props.showStations]
    ])
  ]))
}
}

})